import "@arco-design/web-react/es/Layout/style";
import _Layout from "@arco-design/web-react/es/Layout";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import cs from 'classnames';
import styles from './style/index.module.less';
function Footer(props = {}) {
  const {
    className,
    ...restProps
  } = props;
  return /*#__PURE__*/React.createElement(_Layout.Footer, _extends({
    className: cs(styles.footer, className)
  }, restProps), "\u7801\u4E0A\u89C6\u754C\u79D1\u6280\u6709\u9650\u516C\u53F8");
}
export default Footer;